export const OUT_OF_STOCK_POPUP_STATE_OPEN = 'ProductCatalog::OutOfStock::StateOpen';
export const OUT_OF_STOCK_POPUP_STATE_CLOSE = 'ProductCatalog::OutOfStock::StateClose';
export const OUT_OF_STOCK_FORM_ERROR = 'ProductCatalog::OutOfStock::StateError';
export const OUT_OF_STOCK_FORM_SUCCESS = 'ProductCatalog::OutOfStock::StateSuccess';
export const TOOGLE_AGREEMENT_FIELD_DATA = 'ProductCatalog::OutOfStock::AgreementField';
export const OUT_OF_STOCK_FORM_FIELD_AGREEMENT = 'ProductCatalog::OutOfStock::AgreementField';
export const OUT_OF_STOCK_FORM_NAME = 'ProductCatalog::OutOfStock::FormName';
export const OUT_OF_STOCK_FORM_VIEW = 'FORM_VIEW';
export const OUT_OF_STOCK_SUCCESS_VIEW = 'SUCCESS_VIEW';
export const OUT_OF_STOCK_AGREEMENT_URL = '/shop/sitetext/?key=SHOP_BASKET_SALES_AGREEMENT_POPUP';
export const LOCAL_STORAGE_DATA_KEY = 'outofstockProductIds';
export const OUT_OF_STOCK_STORAGE_DATA = 'outOfStockStorageData';
